// src/utils/tripImportMapper.js

/* -------------------------------------------------------
   Excel Helpers
------------------------------------------------------- */

// Excel serial → JS Date (date ONLY)
export function excelSerialToDate(serial) {
  if (!serial || isNaN(serial)) return null;
  const ms = (Number(serial) - 25569) * 86400 * 1000;
  return new Date(ms);
}

// Format YYYY-MM-DD
export function toYMD(d) {
  if (!d || isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/* -------------------------------------------------------
   Time conversion
------------------------------------------------------- */

function convertTime(v) {
  if (!v) return "";
  if (!isNaN(v)) {
    const serial = Number(v);
    const totalMinutes = Math.round((serial - Math.floor(serial)) * 24 * 60);
    const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
    const mm = String(totalMinutes % 60).padStart(2, "0");
    return `${hh}:${mm}`;
  }
  return v.toString().slice(0, 5);
}

/* -------------------------------------------------------
   Convert many Excel date formats
------------------------------------------------------- */
function convertDate(v) {
  if (!v) return "";

  // Excel serial number
  if (!isNaN(v)) {
    const d = excelSerialToDate(v);
    return toYMD(d);
  }

  // Parse string formats
  try {
    const parts = v.split(/[-/]/);
    if (parts.length === 3) {
      let [a, b, c] = parts.map(Number);

      let y = c < 100 ? 2000 + c : c;

      // If first part > 12 → DD/MM/YYYY
      if (a > 12) {
        return `${y}-${String(b).padStart(2, "0")}-${String(a).padStart(2, "0")}`;
      }

      // Else MM/DD/YYYY
      return `${y}-${String(a).padStart(2, "0")}-${String(b).padStart(2, "0")}`;
    }
  } catch {}

  return v;
}

/* -------------------------------------------------------
   Number helper
------------------------------------------------------- */
const nz = (v) => (v == null || v === "" ? 0 : Number(v));

/* -------------------------------------------------------
   Normalize Keys
------------------------------------------------------- */
const normalizeKeys = (obj) => {
  const out = {};
  for (const k in obj) {
    const nk = k.toLowerCase().replace(/[\s._-]+/g, "");
    out[nk] = obj[k];
  }
  return out;
};

/* -------------------------------------------------------
   MAIN MAPPER FOR ALL CLIENT IMPORTS
------------------------------------------------------- */
export function mapCsvRow(csvRow) {
  const row = normalizeKeys(csvRow);

  const pickup =
    row.pickupaddress ||
    row.pickuplocation ||
    row.pickup ||
    row.from ||
    "";

  const drop =
    row.dropaddress ||
    row.dropoffaddress ||
    row.droplocation ||
    row.to ||
    "";

  return {
    srNo: row.srno || row.serialno || row.sr || "",
    reservationId: row.clienttripid || row.tripid || row.bookingid || "",

    pickupDate: convertDate(row.pickupdate),
    pickupTime: convertTime(row.pickuptime),

    passengerName: row.passengername || row.guestname || "",
    passengerPhone:
      row.passengermobile ||
      row.customerphone ||
      row.passengernumber ||
      row.guestphone ||
      "",

    noOfPassengers: row.noofpassenger || row.noofguests || row.pax || "",
    flightNumber: row.flightno || row.flightnumber || "",

    pickup,
    drop,

    /* 🔥 NEW: These will be filled after geocoding */
    pickupLat: null,
    pickupLng: null,
    dropLat: null,
    dropLng: null,

    carType: row.cartype || row.vehicle || "",
    driver: row.drivername || row.driver || row.plate || "",
    cllTripId: row.clltripid || "",
    comment: row.comments || row.comment || row.remarks || row.notes || "",

    // Pricing fields
    clientFinalPrice: nz(row.clientprice || row.clientamount),
    clientParking: nz(row.clientparking),
    driverFinalPrice: nz(row.driverprice || row.driveramount),
    driverParking: nz(row.driverparking),

    // NEW: Actual Parking
    actualParking:
      nz(row.actualparking) ||
      nz(row.actual_parking) ||
      nz(row["actual parking"]) ||
      nz(row.parkingactual),

    // Auto-calculated
    totalClient:
      nz(row.clientprice || row.clientamount) + nz(row.clientparking),

    totalDriver:
      nz(row.driverprice || row.driveramount) + nz(row.driverparking),

    // Status fields
    status: "uploaded",
    parkingDone: false,
    pricingDone: false,
    finalized: false,
  };
}
